import { LOGOUT, API_BUILD_LOCAL_SEARCH, API_BUILD_LOCAL_RESET } from '../constants/actionTypes'

export default (state = { pagination: { current: 1, pageSize: 10 }}, action) => {
  switch (action.type) {
    case LOGOUT:
      return {}
    case API_BUILD_LOCAL_RESET:
        return {
          pagination: { current: 1, pageSize: 10 },
        }
    case API_BUILD_LOCAL_SEARCH:
      console.log('API_BUILD_LOCAL_SEARCH', action)
      if(action.error){
        return {
          ...state,
          data:[],
          dataApi:{base:'',csv:'', json:'', xml:''}
        }
      }
      return {
        ...state,
        pagination: {
          current: parseInt(action.payload.data.current),
          pageSize: action.payload.data.size,
          total: action.payload.data.total,
        },
        actualTotal: action.payload.data.actualTotal,
        data: action.payload.data.result,
        dataApi: action.payload.data.api
      }
    default:
      return state
  }

  return state
}



// WEBPACK FOOTER //
// src/reducers/apiBuilderLocal.js